import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { Level } from './log-level';
import { Store } from '@ngrx/store';
import { getUser } from '@app/store/user/user.reducer';
import { IUser } from '@app/store/user';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { State } from '../../../store';
import { SSEHubLogService } from '@shared/SSEHubClient/log.service';
import { ServerErrorMessage } from '@models';
import { takeUntil } from 'rxjs/operators';

const CONSOLE_DEBUG_METHOD = console['debug'] ? 'debug' : 'log';

@Injectable({
    providedIn: 'root'
})
export class LoggerService implements OnDestroy {
    // Set log level
    // TODO: Use some form of external configuration
    private level: Level = Level.INFO;

    currentUrl: string;
    logUrl = '/api/error';
    destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<State>,
        private router: Router,
        private sseHubLogService: SSEHubLogService
    ) {
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.currentUrl = val.url;
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    error(message: string, ...optionalParams: any[]) {
        if (!this.isErrorEnabled()) {
            return;
        }

        console.log(message);
        optionalParams.forEach(param => {
            console.log(param);
        });

        const serverErrorMessage = new ServerErrorMessage();
        serverErrorMessage.url = this.currentUrl;
        serverErrorMessage.source = 'CERS website';
        serverErrorMessage.message = message;

        if (optionalParams && optionalParams.length > 0) {
            const val = typeof optionalParams[0] === 'object' ? JSON.stringify(optionalParams[0]) : optionalParams[0].toString();
            serverErrorMessage.optional1 = val;
        }
        for (let i = 1; i < optionalParams.length; i++) {
            const val = typeof optionalParams[i] === 'object' ? JSON.stringify(optionalParams[i]) : optionalParams[i].toString();
            serverErrorMessage.optional2 += val + ' - ';
        }

        if (window.navigator.onLine) {
            this.sseHubLogService.logError(serverErrorMessage);
        }

    }

    warn(message: any, ...optionalParams: any[]) {
        this.isWarnEnabled() && console.warn.apply(console, arguments);
    }

    info(message?: any, ...optionalParams: any[]) {
        this.isInfoEnabled() && console.log.apply(console, arguments);
    }

    debug(message: any, ...optionalParams: any[]) {
        this.isDebugEnabled() && (<any>console)[CONSOLE_DEBUG_METHOD].apply(console, arguments);
    }

    log(message: any, ...optionalParams: any[]) {
        this.isLogEnabled() && console.log.apply(console, arguments);
    }

    isErrorEnabled = (): boolean => this.level >= Level.ERROR;
    isWarnEnabled = (): boolean => this.level >= Level.WARN;
    isInfoEnabled = (): boolean => this.level >= Level.INFO;
    isDebugEnabled = (): boolean => this.level >= Level.DEBUG;
    isLogEnabled = (): boolean => this.level >= Level.LOG;

    private logErrormessageOnServer(message: ServerErrorMessage): Observable<any> {
        return of(1);
    }
}


